/**
 * Version applicative — clippit-cra frontend (CRA collaborateurs).
 *
 * NE PAS MODIFIER À LA MAIN. Cette constante est réécrite par le workflow
 * Release à chaque push sur `main`, en même temps que le fichier VERSION à la
 * racine, les trois package.json et le version.ts du portail client. La source
 * de vérité est le fichier VERSION ; l'outil est scripts/release-version.sh.
 *
 * Convention SemVer, appliquée par un marqueur dans le message du commit qui
 * atterrit sur `main` (donc le message de merge de la pull request) :
 *   - [major] : changement structurant ou cassant (API, modèle de données).
 *   - [minor] : nouvelle fonctionnalité visible.
 *   - aucun marqueur : correctif ou finition, incrément de correctif par défaut.
 *   - [skip release] : ni release ni déploiement.
 *
 * L'historique des versions vit dans CHANGELOG.md, généré automatiquement à
 * partir des commits de chaque release. Détails dans docs/RELEASES.md.
 */
export const APP_VERSION = '1.8.0';
